/* Global cart drawer. Exposes window.VlxCartDrawer.open(cart?) / .close().
   Renders line items from /cart.js using createElement/textContent (no innerHTML
   concatenation of merchant data). Quantity comes from state, not the DOM text,
   and buttons are disabled while a change is in flight to avoid lost updates. */
(function () {
  var root = document.getElementById('CartDrawer');
  if (!root) return;

  var itemsEl = root.querySelector('[data-drawer-items]');
  var emptyEl = root.querySelector('[data-drawer-empty]');
  var footEl = root.querySelector('[data-drawer-foot]');
  var subtotalEl = root.querySelector('[data-drawer-subtotal]');
  var lastFocus = null;
  var inFlight = false;

  function money(cents) {
    return 'S/. ' + (cents / 100).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function sizedImage(url, w) {
    return url ? url.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2') : '';
  }

  function render(cart) {
    if (!cart || !cart.items) { showError(); return; }
    var badgeCount = window.VLX ? window.VLX.realCount(cart) : cart.item_count;
    document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = badgeCount; });
    var hasItems = (window.VLX ? window.VLX.units(cart) : cart.item_count) > 0;
    emptyEl.hidden = hasItems;
    footEl.hidden = !hasItems;
    itemsEl.textContent = '';

    cart.items.forEach(function (item) {
      // The province fee brick is a real line but not a product — never list it here.
      if (window.VLX && window.VLX.feeVariant() && item.variant_id === window.VLX.feeVariant()) return;
      var li = el('li', 'vlx-drawer-item');
      li.setAttribute('data-key', item.key);
      li.setAttribute('data-qty', item.quantity);

      var media = el('a', 'vlx-drawer-item__media');
      media.href = item.url;
      if (item.image) {
        var img = el('img');
        img.src = sizedImage(item.image, 120);
        img.alt = item.product_title || '';
        img.width = 60; img.height = 60; img.loading = 'lazy';
        media.appendChild(img);
      }
      li.appendChild(media);

      var info = el('div', 'vlx-drawer-item__info');
      var title = el('a', 'vlx-drawer-item__title', item.product_title);
      title.href = item.url;
      info.appendChild(title);
      if (item.variant_title) info.appendChild(el('p', 'vlx-drawer-item__variant', item.variant_title));

      var row = el('div', 'vlx-drawer-item__row');
      var qty = el('div', 'vlx-qty vlx-qty--sm');
      var minus = el('button', 'vlx-qty__btn', '−'); minus.type = 'button';
      minus.setAttribute('data-dminus', ''); minus.setAttribute('aria-label', 'Menos');
      var val = el('span', 'vlx-qty__val', item.quantity);
      var plus = el('button', 'vlx-qty__btn', '+'); plus.type = 'button';
      plus.setAttribute('data-dplus', ''); plus.setAttribute('aria-label', 'Más');
      qty.appendChild(minus); qty.appendChild(val); qty.appendChild(plus);
      row.appendChild(qty);
      row.appendChild(el('span', 'vlx-drawer-item__price', money(item.final_line_price)));
      info.appendChild(row);

      li.appendChild(info);
      itemsEl.appendChild(li);
    });
    if (subtotalEl) {
      var feeLn = window.VLX ? window.VLX.feeLine(cart) : null;
      subtotalEl.textContent = money(cart.total_price - (feeLn ? feeLn.final_line_price : 0));
    }
  }

  function showError() {
    itemsEl.textContent = '';
    emptyEl.hidden = false;
    emptyEl.textContent = 'No pudimos cargar tu carrito. Recarga la página o vuelve a intentar.';
    footEl.hidden = true;
  }

  function change(key, qty) {
    if (inFlight) return;
    inFlight = true;
    root.querySelectorAll('[data-dminus],[data-dplus]').forEach(function (b) { b.disabled = true; });
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(render)
      .catch(function () {
        // fall back to the server's truth; if that also fails, show an error
        fetch('/cart.js').then(function (r) { return r.json(); }).then(render).catch(showError);
      })
      .finally(function () {
        inFlight = false;
        root.querySelectorAll('[data-dminus],[data-dplus]').forEach(function (b) { b.disabled = false; });
      });
  }

  itemsEl.addEventListener('click', function (e) {
    var li = e.target.closest('[data-key]'); if (!li) return;
    var key = li.getAttribute('data-key');
    var q = parseInt(li.getAttribute('data-qty'), 10) || 1;
    if (e.target.closest('[data-dminus]')) change(key, Math.max(0, q - 1));
    else if (e.target.closest('[data-dplus]')) change(key, q + 1);
  });

  function open(cart) {
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    root.querySelector('.vlx-drawer__close').focus();
    if (cart) render(cart);
    else fetch('/cart.js').then(function (r) { return r.json(); }).then(render).catch(showError);
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  root.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  document.querySelectorAll('.vlx-header__cart').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });

  window.VlxCartDrawer = { open: open, close: close };
})();
